<span [class]="'mo-loading ' + size + ' ' + color"></span>
